"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Plottable = _interopRequireWildcard(require("plottable"));
var _setXYScaleDomain = _interopRequireDefault(require("./setXYScaleDomain"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * Function to build the axes for plot based on some metadata about the chart data.
 * It's a general function to simplify configuration for Plottable JS axes (and scales)
 * in 99% use-cases by other projects.
 *
 * @param isTimeSeries - indicates if it's a time series chart to use time axis
 * @param isCategorical - indicates if it's a categorical chart to use categorical axis
 * @param isLongText - indicates that it needs to set max width for label
 * @param isAxisInverted - indicates that it needs to display x and y axes vice verse.
 * @param xAxisDomain - parameter to display a defined range of data (or a set of category values)
 * @param yAxisDomain - parameter to display a defined range for y axis
 * @returns {{xScale: *, xAxis: *, yScale: Linear, yAxis: Numeric}}
 */
var buildXYAxes = function buildXYAxes(_ref) {
  var isTimeSeries = _ref.isTimeSeries,
    isCategorical = _ref.isCategorical,
    _ref$isLongText = _ref.isLongText,
    isLongText = _ref$isLongText === void 0 ? false : _ref$isLongText,
    _ref$isAxisInverted = _ref.isAxisInverted,
    isAxisInverted = _ref$isAxisInverted === void 0 ? false : _ref$isAxisInverted,
    xAxisDomain = _ref.xAxisDomain,
    yAxisDomain = _ref.yAxisDomain;
  var xScale;
  var xAxis;
  var xOrientation = isAxisInverted ? 'left' : 'bottom';
  var yOrientation = isAxisInverted ? 'bottom' : 'left';

  // X-Axis
  if (isTimeSeries) {
    xScale = new Plottable.Scales.Time();
    xAxis = new Plottable.Axes.Time(xScale, xOrientation);
  } else if (isCategorical) {
    xScale = new Plottable.Scales.Category();
    xAxis = new Plottable.Axes.Category(xScale, xOrientation);
    if (isLongText && !isAxisInverted) {
      xAxis.tickLabelAngle(-90).tickLabelShearAngle(60).tickLabelMaxWidth(30);
    }
  } else {
    xScale = new Plottable.Scales.Linear();
    xAxis = new Plottable.Axes.Numeric(xScale, xOrientation);
  }
  (0, _setXYScaleDomain["default"])(xScale, xAxisDomain);

  // Y-Axis
  var yScale = new Plottable.Scales.Linear();
  var yAxis = new Plottable.Axes.Numeric(yScale, yOrientation);
  (0, _setXYScaleDomain["default"])(yScale, yAxisDomain);
  return {
    xScale: xScale,
    xAxis: xAxis,
    yScale: yScale,
    yAxis: yAxis
  };
};
var _default = exports["default"] = buildXYAxes;
//# sourceMappingURL=buildXYAxes.js.map